import apis from '@api/api';

const CustomAssetManagerPlugin = (editor, options = {}) => {
	const am = editor.AssetManager;

	// Function to load assets initially
	const loadAssets = async () => {
		await apis
			.getGlobalAssets(false) // Request just URL strings, not full metadata
			.then((assets) => {
				am?.add(assets); // Add the fetched assets to the Asset Manager
				am?.render(); // Render/refresh the Asset Manager view
			})
			.catch((error) => {
				console.error('Error fetching assets:', error);
			});
	};

	// Function to handle the addition of new assets to the Asset Manager
	const handleNewAsset = (asset) => {
		// Here you can define how new assets are handled
		// For example, logging the new asset, adding to the manager, etc.
		am?.add(asset);
		am?.render(); // Ensure the Asset Manager updates
	};

	// Call the loadAssets function on plugin initialization
	loadAssets();

	// Listen for asset added event and trigger handleNewAsset
	editor.on('asset:add', (asset) => {
		handleNewAsset(asset); // Update Asset Manager with the new asset
	});

	// Return the plugin object with initialization logic
	return {
		init() {
			// You can add other initialization logic here if needed
			console.log('Custom Asset Manager Plugin Initialized');
		},
	};
};

export default CustomAssetManagerPlugin;
